import { render, staticRenderFns } from "./CriticismMessage.vue?vue&type=template&id=793505ce"
import script from "./CriticismMessage.vue?vue&type=script&lang=js"
export * from "./CriticismMessage.vue?vue&type=script&lang=js"
import style0 from "./CriticismMessage.vue?vue&type=style&index=0&id=793505ce&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports